import React from "react";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import ProviderItemContainer from "Containers/ProviderItemContainer";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import Button from "ComponentsUI/Button";
import { AdverBlockContainer } from "Containers/AdBlocksContainer";
import withStyles from "react-jss";
import ProviderConnectHOC from "HOC/ProviderConnectHOC";
import Metrika from "Services/Metrika";
import { Link } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { inject } from "mobx-react";
import { getPhoneNumberByCode } from "Utils/siteConfig";
import routes from "Configs/routes";

const styles = (theme) => ({
	root: {},
	wrapper: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		flexWrap: "wrap",
	},
	blocksWrapper: {
		marginBottom: "20px",
		width: "100%",
		borderRadius: "10px",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	noFlatWrapper: {
		marginRight: "-10px",
		marginLeft: "-10px",
	},
	adblock: {
		width: "100%",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		noFlatWrapper: {
			marginRight: "-5px",
			marginLeft: "-5px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		noFlatWrapper: {
			marginRight: "0",
			marginLeft: 0,
		},
		blocksWrapper: {
			marginBottom: "0",
		},
		adblock: {
			margin: "0 -20px",
			width: "auto",
		},
	},
});

@inject("ApplicationModel")
class ProvidersList extends React.Component {
	static defaultProps = {
		sendMetrica: () => {},
		withoutAdBlock: false,
	};

	constructor(props) {
		super(props);
	}

	onProviderSelect(provider) {
		this.props.history.push({
			pathname: generateUrl(routes.ProviderDetails.route, {
				providerName: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	}

	onProviderRates(provider) {
		this.props.history.push({
			pathname: generateUrl(routes.ProviderRates.route, {
				providerName: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	}

	onProviderConnect(provider) {
		let {
			ApplicationModel: { tariffsModel },
		} = this.props;
		tariffsModel.setProvider(provider);
	}

	onProviderReviews(provider) {}

	componentDidMount() {
		this.sendYandexMetrika();
	}

	sendYandexMetrika() {
		try {
			Metrika.getInstance().yandex.sendEvent(this.props.yandexEvent, {
				params: { providers_count_view: this.props.items.length },
			});
		} catch (e) {
			console.warn("Error sendMetrica", e);
		}
	}

	generateProviders() {
		let items = this.props.items;
		let classes = this.props.classes;
		let siteCode = this.props.ApplicationModel.siteCode;
		if (!this.props.windowSize.xs && !this.props.flat) {
			let blocks = [];
			let adElem = [
				<div className={classes.adblock} key={"adblock2"}>
					<AdverBlockContainer key="adblock2" isRatesAddForm={this.props.isRatesAddForm} />
				</div>,
			];
			items.map((item, index) => {
				if (!item?.sell_self?.provider?.name) {
					blocks.push(
						<ProviderConnectHOC key={"i" + index} callbackFn={() => this.onProviderConnect(item)}>
							<ProviderItemContainer
								catalogProviders={this.props.catalogProviders}
								text={this.props.text}
								onProviderSelect={() => this.onProviderSelect(item)}
								onProviderRates={() => this.onProviderRates(item)}
								onProviderReviews={() => this.onProviderReviews(item)}
								data={item}
								windowSize={this.props.windowSize}
								flat={this.props.flat}
								ratesView={this.props.ratesView}
								siteCode={siteCode}
							/>
						</ProviderConnectHOC>
					);
				} else {
					blocks.push(
						<ProviderConnectHOC key={"i" + index} callbackFn={() => this.onProviderConnect(item)}>
							<ProviderItemContainer
								selled={true}
								catalogProviders={this.props.catalogProviders}
								text={this.props.text}
								onProviderSelect={() => this.onProviderSelect(item)}
								onProviderRates={() => this.onProviderRates(item)}
								onProviderReviews={() => this.onProviderReviews(item)}
								data={item}
								windowSize={this.props.windowSize}
								flat={this.props.flat}
								ratesView={this.props.ratesView}
								siteCode={siteCode}
							/>
						</ProviderConnectHOC>
					);
				}
			});
			if (blocks.length > 8) {
				blocks.splice(8, 0, adElem);
			} else {
				blocks.push(adElem);
			}
			return blocks;
		} else {
			let blocks = [];
			let lastWasElite = false;
			let itemsInBlock = [];
			let blocksCounter = 0;
			let adBlockWasAdded = this.props.withoutAdBlock;
			let adBlockPlace = 8;
			for (var i = 0; i < items.length; i++) {
				let item = items[i];
				if (
					!!parseInt(item.vip_provider) === lastWasElite &&
					(adBlockWasAdded || i != adBlockPlace)
				) {
					if (!item?.sell_self?.provider?.name) {
						itemsInBlock.push(
							<ProviderConnectHOC key={i} callbackFn={() => this.onProviderConnect(item)}>
								<ProviderItemContainer
									text={this.props.text}
									catalogProviders={this.props.catalogProviders}
									onProviderSelect={() => this.onProviderSelect(item)}
									onProviderRates={() => this.onProviderRates(item)}
									onProviderReviews={() => this.onProviderReviews(item)}
									data={item}
									windowSize={this.props.windowSize}
									flat={this.props.flat && !this.props.windowSize.xs}
									ratesView={this.props.ratesView}
									siteCode={siteCode}
								/>
							</ProviderConnectHOC>
						);
					} else {
						itemsInBlock.push(
							<ProviderConnectHOC key={i} callbackFn={() => this.onProviderConnect(item)}>
								<ProviderItemContainer
									selled={true}
									text={this.props.text}
									catalogProviders={this.props.catalogProviders}
									onProviderSelect={() => this.onProviderSelect(item)}
									onProviderRates={() => this.onProviderRates(item)}
									data={item}
									windowSize={this.props.windowSize}
									flat={this.props.flat && !this.props.windowSize.xs}
									ratesView={this.props.ratesView}
									siteCode={siteCode}
								/>
							</ProviderConnectHOC>
						);
					}
				} else {
					if (itemsInBlock.length > 0) {
						blocks.push(
							<div key={blocksCounter} className={classes.blocksWrapper}>
								{itemsInBlock}
							</div>
						);
					}
					if (!adBlockWasAdded && i == adBlockPlace && !this.props.withoutAdBlock) {
						blocks.push(
							<div className={classes.adblock} key={"adblock2"}>
								<AdverBlockContainer key="adblock2" isRatesAddForm={this.props.isRatesAddForm} />
							</div>
						);
						adBlockWasAdded = true;
					}
					itemsInBlock = [];
					blocksCounter++;
					i--;
					lastWasElite = !lastWasElite;
				}
				if (i == items.length - 1) {
					if (itemsInBlock.length > 0) {
						blocks.push(
							<div key={blocksCounter} className={classes.blocksWrapper}>
								{itemsInBlock}
							</div>
						);
					}
				}
			}
			if (!adBlockWasAdded && !this.props.withoutAdBlock) {
				blocks.push(
					<div className={classes.adblock} key={"adblock2"}>
						<AdverBlockContainer key="adblock2" isRatesAddForm={this.props.isRatesAddForm} />
					</div>
				);
				adBlockWasAdded = true;
			}
			return blocks;
		}
	}

	render() {
		const {
			text,
			match: { params },
		} = this.props;
		const classes = this.props.classes;

		const toHomeURL = generateUrl(Routes.OrderToHome.route, {
			regionUrl: params.regionUrl,
		});

		const siteCode = this.props.ApplicationModel.siteCode;
		const phoneNumber = getPhoneNumberByCode(siteCode);

		function displayText() {
			return (
				<div>
					Похоже, что по Вашему запросу нет подходящих тарифов. Попробуйте сбросить значения
					фильтров. Или позвоните нам по номеру{" "}
					<span style={{ whiteSpace: "nowrap" }}>{phoneNumber}</span> и оператор вас
					проконсультирует!
				</div>
			);
		}

		if (!this.props.items.length) {
			return (
				<Container>
					<Row>
						<Col
							lg={{ size: 4, offset: 4 }}
							md={{ size: 4, offset: 4 }}
							sm={{ size: 4, offset: 4 }}
							xs={{ size: 6, offset: 3 }}
						>
							<EmptyStub
								header={text.NO_PROVIDERS_HEADER}
								text={displayText()}
								icon={
									<span
										className="icon48 icon-balance"
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
									/>
								}
								button={
									<Button
										component={<Link to={toHomeURL} />}
										typeText={"small"}
										size={"low"}
										status={"purple"}
									>
										<span
											className="icon48 icon-playlist-add"
											style={{
												fontSize: "24px",
												color: "#d3cee1",
											}}
										/>
										{text.upperMenuFindInternet}
									</Button>
								}
							/>
						</Col>
					</Row>
				</Container>
			);
		}
		return (
			<div className={classes.root}>
				<Container>
					<Row>
						<Col xs={12}>
							<div
								className={classNames(classes.wrapper, {
									[classes.noFlatWrapper]: !this.props.flat,
								})}
							>
								{this.generateProviders()}
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default withRouter(withStyles(styles)(ProvidersList));
